<rt-activity-subscriptions-table
  *ngIf="
    (abilities.viewOffers && abilities.viewCandidates) ||
    (abilities.manageJobsReferralSettings && hasReferrals)
  "
  [types]="types"
  [title]="title"
>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.viewOffers && abilities.viewCandidates"
    icon="person"
    [title]="'app.subscriptions.events_group.candidate_apply_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['candidateApply']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.viewOffers && abilities.viewCandidates"
    icon="merge-type"
    [title]="'app.subscriptions.events_group.candidate_add_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['candidateAdd', 'candidateImport', 'candidateMerge']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="hasOverdueCandidates && abilities.viewOffers && abilities.viewCandidates"
    [title]="'app.subscriptions.events_group.candidate_overdue_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['jobOverdueCandidates']"
    [notifyInfo]="true"
    (changeEvents)="changeEvents.emit($event)"
    icon="alarm"
  ></rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.viewOffers && abilities.viewCandidates"
    icon="remove-red-eye"
    [title]="'app.subscriptions.events_group.job_status_change_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="[
      'jobStatusChange',
      'jobAutoPublishFail',
      'jobAutoCloseFail',
      'jobSchedulerChange',
      'jobStatusAutoChange',
      'jobSchedulerClear'
    ]"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="hasRequisitions"
    icon="remove-red-eye"
    [title]="'app.subscriptions.events_group.requisition_job_published' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['jobPublishedRequisitionMismatch']"
    (changeEvents)="changeEvents.emit($event)"
  ></rt-activity-subscriptions-table-row>
  <ng-container *ngIf="hasReferrals">
    <rt-activity-subscriptions-table-row
      *ngIf="abilities.manageJobsReferralSettings"
      icon="navbar-referrals"
      [title]="'app.subscriptions.events_group.referral_offer_status_change_v2' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['referralOfferStatusChange']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
    <rt-activity-subscriptions-table-row
      *ngIf="abilities.manageJobsReferralSettings"
      icon="reward"
      [title]="'app.subscriptions.events_group.referral_assign_remove_v2' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['referralRewardAssigned', 'referralRewardUnassigned']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
    <rt-activity-subscriptions-table-row
      *ngIf="abilities.viewOffers && abilities.viewCandidates"
      icon="navbar-referrals"
      [title]="'app.subscriptions.events_group.candidate_referred_v2' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['candidateReferred']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
  </ng-container>
</rt-activity-subscriptions-table>
